<div class="jinni-carousel row">
  <div class="mw xl-12 md-12 sm-12 xs-12">
    <div class="carousel-container" [ngClass]="{'done': done}">
      <owl-carousel *ngIf="itemsSize"
                    [options]="{dotsEach: true, nav: true, checkVisible: true, lazyLoad: true, stageElement: disable, autoWidth: false, responsiveClass: true, responsive:{
                            '0':{ items:2 },
                            '1200':{ items:3 }
                            }}"
                    [items]="itemsArr"
                    [carouselClasses]="['owl-carousel','owl-theme','owl-drag', 'row']">
        <div class="item" *ngFor='let in of counter(itemsSize) ;let i = index'>
          <div class="slide lottery-{{ valueOfIndex(i,'urlLotteryName') }}">
            <div class="lottery-top">
              <div class="name">{{ valueOfIndex(i, 'LotteryName') }}</div>
              <div class="award">
                <span
                  *ngIf="currency && currency.Code && itemsArr[i]['Rates']['MoreRoundedJackpot'][currency.Code] && jackpotConfig.downloadedData">{{itemsArr[i]['Rates']['MoreRoundedJackpot'][currency.Code] | currency: currency.Code:currency.Symbol:'0.0':(subscriptionsService.countryCodeValue || 'en') | jackpot: (subscriptionsService.countryCodeValue || 'en'):currency.Symbol:showLang:false}}</span>
              </div>
            </div>
            <div class="logo-bg"></div>
            <div class="lottery-bg"></div>
            <div class="logo-icon"></div>
            <div class="lottery-bottom">
              <div class="time"></div>
              <div class="przycisk green medium btn-playnow">
                <a
                  [routerLink]="['/' + showLang, 'lotteries', valueOfIndex(i,'urlLotteryName')]">{{ 'carousel.betNow' | translate }}</a>
              </div>
              <app-universalcounter
                [lottery]="valueOfIndex(i,'LotteryID')">{{ 'carousel.loading' | translate }}</app-universalcounter>
            </div>
          </div>
        </div>
      </owl-carousel>
    </div>
  </div>
</div>

